import './cadastro.css';
import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import Checkbox from '../../../rxlib/components/checkbox';
import InputLabel from '../../../rxlib/components/input-label';
import TextareaLabel from '../../../rxlib/components/textarea-label';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { SelectLabelAsync } from '../../../rxlib/components/select/select-label-async';
import { ApiError, ItemLicencaOrganizacaoTemp, ItemLicencaOrganizacao } from '../../../services/tipos';

interface ItemLicencaOrganizacaoCadastroProps {
    show: boolean;
    readOnly: boolean;
    onHide: () => void;
    idLicencaOrganizacao: string;
    onSalvar: (valor: boolean) => void;
    idItemLicencaOrganizacaoTemp: string;
    fonteDados: [ItemLicencaOrganizacaoTemp];
    setFonteDados: (fonteDados: [ItemLicencaOrganizacaoTemp]) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function ItemLicencaOrganizacaoCadastro(props: ItemLicencaOrganizacaoCadastroProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [tipoControleItemLicencaOrganizacao, setTipoControleItemLicencaOrganizacao] = useState<number>(0);

    const [itemLicencaOrganizacao, setItemLicencaOrganizacao] = useState<ItemLicencaOrganizacao>({
        id: '',
        valorItem: '',
        idItemLicenca: '',
        personalizado: true,
        idItemLicencaBase: undefined,
    });

    const tipoControleFlag = 2;
    const tipoControlePersonalizado = 3;

    const { register, handleSubmit } = useForm<ItemLicencaOrganizacaoTemp>();

    const onHideWarning = () => {
        setShowWarning(false);
    }

    const temPermissao = props.readOnly
        ? usuarioTemPermissao(token, 'itens_licenca_organizacao_visualizar')
        : props.idItemLicencaOrganizacaoTemp
            ? usuarioTemPermissao(token, 'itens_licenca_organizacao_editar')
            : usuarioTemPermissao(token, 'itens_licenca_organizacao_novo');

    useEffect(() => {
        setItemLicencaOrganizacao({
            id: '',
            valorItem: '',
            idItemLicenca: '',
            personalizado: true,
            idItemLicencaBase: undefined,
        });

        if (temPermissao) {
            if (props.idItemLicencaOrganizacaoTemp) {
                let item: ItemLicencaOrganizacaoTemp[] = props.fonteDados.filter((item) => String(item.tempId) === String(props.idItemLicencaOrganizacaoTemp));
                if (item.length > 0) {
                    setItemLicencaOrganizacao({
                        id: item[0].id,
                        valorItem: item[0].valorItem,
                        personalizado: item[0].personalizado,
                        idItemLicenca: item[0].itemLicenca.id,
                        idItemLicencaBase: item[0].idItemLicencaBase,
                    });
                }
            }
        } else {
            setCarregando(false);
            setMessageWarning(['Usuário logado não tem permissão para realizar essa ação com o item da licença.']);
            setShowWarning(true);
        }
    }, [props, temPermissao]);

    const onSubmit: SubmitHandler<ItemLicencaOrganizacaoTemp> = data => {
        if (!tipoControleEPersonalizado()) {
            if (tipoControleEFlag()) {
                if ((data.valorItem !== '0') && (data.valorItem !== '1')) {
                    setMessageWarning(['Itens do tipo flag permitem apenas os valores 0 ou 1.']);
                    setShowWarning(true);
                } else {
                    salvar(data);
                }
            } else {
                salvar(data);
            }
        } else {
            salvar(data);
        }
    }

    function salvar(data: ItemLicencaOrganizacaoTemp) {
        setCarregando(true);
        api.get(`/ItemLicenca/${data.idItemLicenca}`)
            .then(response => {
                let dados: ItemLicencaOrganizacaoTemp = {
                    id: data.id,
                    valorItem: data.valorItem,
                    idItemLicenca: data.idItemLicenca,
                    personalizado: Boolean(data.personalizado),
                    idItemLicencaBase: data.idItemLicencaBase === '0' ? undefined : data.idItemLicencaBase,
                    idLicencaOrganizacao: data.idLicencaOrganizacao === '0' ? undefined : data.idLicencaOrganizacao,
                    tempId: (props.idItemLicencaOrganizacaoTemp !== '') ? parseInt(props.idItemLicencaOrganizacaoTemp) : obterProximoTempId(),
                    itemLicenca: {
                        id: response.data.id,
                        nome: response.data.nome,
                        chave: response.data.chave,
                        tipoControle: response.data.tipoControle,
                    }
                };

                props.idItemLicencaOrganizacaoTemp
                    ? editar(dados)
                    : incluir(dados);
            });
    }

    function obterProximoTempId() {
        let proximo = 0;
        for (var contador = 0; contador < props.fonteDados.length; contador++) {
            if (props.fonteDados[contador].tempId > proximo)
                proximo = props.fonteDados[contador].tempId;
        }
        return proximo + 1;
    }

    function incluir(data: ItemLicencaOrganizacaoTemp) {
        try {
            let novosDados = props.fonteDados;
            if (novosDados[0].tempId === 0) {
                novosDados[0] = data;
            } else {
                novosDados.push(data);
            }

            props.setFonteDados(novosDados);
            informarSucesso();
        } catch (error: any) {
            setCarregando(false);
            props.tratarErro(error, 'Não foi possível salvar o item da licença: ');
        }
    }

    function editar(data: ItemLicencaOrganizacaoTemp) {
        let dados: [ItemLicencaOrganizacaoTemp] = [{
            id: '',
            tempId: 0,
            valorItem: '',
            idItemLicenca: '',
            personalizado: true,
            idLicencaOrganizacao: '',
            idItemLicencaBase: undefined,
            itemLicenca: {
                id: '',
                nome: '',
                chave: '',
                tipoControle: '',
            },
        }];

        function AddItemDados(item: ItemLicencaOrganizacaoTemp) {
            if (String(item.tempId) !== String(data.tempId)) {
                if (!dados[0]['tempId']) {
                    dados[0] = item;
                } else {
                    dados.push(item);
                }
            }
        }

        try {
            props.fonteDados.map(item => (
                AddItemDados(item)
            ));

            if (dados[0].tempId === 0) {
                dados[0] = data;
            } else {
                dados.push(data);
            }

            props.setFonteDados(dados);
            informarSucesso();
        } catch (error: any) {
            setCarregando(false);
            props.tratarErro(error, 'Não foi possível salvar o item da licença: ');
        }
    }

    function informarSucesso() {
        props.onHide();
        props.onSalvar(true);
        setCarregando(false);
    }

    function onChangeItemLicenca(idItemLicenca: string) {
        api.get(`/ItemLicenca/${idItemLicenca}`)
            .then(response => {
                setTipoControleItemLicencaOrganizacao(response.data.tipoControle);
            });
    }

    function tipoControleEFlag(): boolean {
        return (tipoControleItemLicencaOrganizacao === tipoControleFlag);
    }

    function tipoControleEPersonalizado(): boolean {
        return (tipoControleItemLicencaOrganizacao === tipoControlePersonalizado);
    }

    function getDialogClassName(): string {
        let modalContent: string = (props.idItemLicencaOrganizacaoTemp !== '')
            ? ((itemLicencaOrganizacao.idItemLicencaBase) && (!itemLicencaOrganizacao.personalizado) && (!props.readOnly))
                ? tipoControleEPersonalizado()
                    ? 'naja-modal-content-item-licenca-organizacao-view-personalizado-readonly'
                    : 'naja-modal-content-item-licenca-organizacao-view-readonly'
                : tipoControleEPersonalizado()
                    ? 'naja-modal-content-item-licenca-organizacao-view-personalizado'
                    : 'naja-modal-content-item-licenca-organizacao-view'
            : ((itemLicencaOrganizacao.idItemLicencaBase) && (!itemLicencaOrganizacao.personalizado) && (!props.readOnly))
                ? tipoControleEPersonalizado()
                    ? 'naja-modal-content-item-licenca-organizacao-personalizado-readonly'
                    : 'naja-modal-content-item-licenca-organizacao-readonly'
                : tipoControleEPersonalizado()
                    ? 'naja-modal-content-item-licenca-organizacao-personalizado'
                    : 'naja-modal-content-item-licenca-organizacao';

        return 'naja-modal-item-licenca-organizacao ' + modalContent;
    }

    function isReadOnlySelect(): boolean {
        return props.readOnly
            ? true
            : itemLicencaOrganizacao.idItemLicencaBase
                ? true
                : false;
    }

    function isReadOnlyInput(): boolean {
        return props.readOnly
            ? true
            : itemLicencaOrganizacao.personalizado
                ? false
                : true;
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} dialogClassName={getDialogClassName()} centered>
                <Modal.Body className='naja-modal-body-detalhe-item-licenca-organizacao'>
                    <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                        <div className='container-fluid'>
                            <div className='row px-1'>
                                <div className='col-11'>
                                    <h6>{props.readOnly ? 'Visualizar' : props.idItemLicencaOrganizacaoTemp ? 'Editar' : 'Novo'} item da licença</h6>
                                </div>
                                <div className='col-1 naja-btn-close-cell-detalhe-item-licenca-organizacao'>
                                    <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
                                </div>
                            </div>
                            {
                                itemLicencaOrganizacao.id
                                    ? <div className='row px-1'>
                                        <div className='col-12 mt-1'>
                                            <InputLabel
                                                name='id'
                                                type='text'
                                                maxLength={50}
                                                readOnly={true}
                                                label='Código:'
                                                autoFocus={false}
                                                id='inputIdDetalhe'
                                                className='rxlib-input-label-coluna'
                                                placeholder='Código do item da licença'
                                                defaultValue={itemLicencaOrganizacao.id}
                                                referencia={register({ required: true })} />
                                        </div>
                                    </div>
                                    : props.idItemLicencaOrganizacaoTemp
                                        ? <div className='row px-1'>
                                            <div className='col-12 mt-1'>
                                                <InputLabel
                                                    type='text'
                                                    maxLength={50}
                                                    readOnly={true}
                                                    autoFocus={false}
                                                    id='inputIdDetalhe'
                                                    label='Código temporário:'
                                                    name='idItemLicencaOrganizacaoTemp'
                                                    className='rxlib-input-label-coluna'
                                                    placeholder='Código do item da licença'
                                                    referencia={register({ required: true })}
                                                    defaultValue={props.idItemLicencaOrganizacaoTemp} />
                                            </div>
                                        </div>
                                        : ''
                            }
                            <div className='row px-1 d-none'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        type='text'
                                        maxLength={50}
                                        readOnly={true}
                                        autoFocus={false}
                                        name='idLicencaOrganizacao'
                                        id='inputIdLicencaOrganizacao'
                                        className='rxlib-input-label-coluna'
                                        label='Código da licença da organização:'
                                        referencia={register({ required: true })}
                                        placeholder='Código da licença da organização'
                                        defaultValue={props.idLicencaOrganizacao ? props.idLicencaOrganizacao : '0'} />
                                </div>
                            </div>
                            <div className='row px-1 d-none'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        type='text'
                                        maxLength={50}
                                        readOnly={true}
                                        autoFocus={false}
                                        name='idItemLicencaBase'
                                        id='inputIdItemLicencaBase'
                                        className='rxlib-input-label-coluna'
                                        label='Código do item da licença base:'
                                        referencia={register({ required: true })}
                                        placeholder='Código do item da licença base'
                                        defaultValue={itemLicencaOrganizacao.idItemLicencaBase ? itemLicencaOrganizacao.idItemLicencaBase : '0'} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    <SelectLabelAsync
                                        foco='sim'
                                        type='ItemLicenca'
                                        name='idItemLicenca'
                                        id='inputIdItemLicenca'
                                        className='rxlib-select-label-coluna'
                                        action={isReadOnlySelect() ? 'view' : ''}
                                        referencia={register({ required: true })}
                                        onChangeValueSelected={onChangeItemLicenca}
                                        valorSelecionado={itemLicencaOrganizacao.idItemLicenca}
                                        label={itemLicencaOrganizacao.idItemLicencaBase ? 'Item de licença base:' : 'Item de licença:'} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    {
                                        (tipoControleEPersonalizado())
                                            ? <TextareaLabel
                                                rows={10}
                                                size='coluna'
                                                label='Valor:'
                                                name='valorItem'
                                                maxLength={2000}
                                                autoFocus={true}
                                                id='inputValorItem'
                                                placeholder='Valor do item'
                                                readOnly={isReadOnlyInput()}
                                                referencia={register({ required: true })}
                                                defaultValue={itemLicencaOrganizacao.valorItem} />
                                            : <InputLabel
                                                type='text'
                                                maxLength={2}
                                                mask='number'
                                                label='Valor:'
                                                name='valorItem'
                                                autoFocus={true}
                                                id='inputValorItem'
                                                placeholder='Valor do item'
                                                readOnly={isReadOnlyInput()}
                                                className='rxlib-input-label-coluna'
                                                referencia={register({ required: true })}
                                                defaultValue={itemLicencaOrganizacao.valorItem} />
                                    }
                                </div>
                            </div>
                            <div className='row px-1 d-none'>
                                <div className='col-12 mt-2'>
                                    <Checkbox
                                        name='personalizado'
                                        referencia={register}
                                        disabled={props.readOnly}
                                        text='Permitir personalização por organização'
                                        value={String(itemLicencaOrganizacao.personalizado)}
                                        defaultChecked={itemLicencaOrganizacao.personalizado} />
                                </div>
                            </div>
                            {
                                ((itemLicencaOrganizacao.idItemLicencaBase) && (!itemLicencaOrganizacao.personalizado) && (!props.readOnly))
                                    ? <div className='row px-1 legenda-personalizado'>
                                        <div className='col-12 mt-2'>
                                            <span>Este item não permite personalização por organização</span>
                                        </div>
                                    </div>
                                    : ''
                            }
                            <ButtonsCrud
                                carregando={carregando}
                                styleButton='btn-rxlib'
                                visualizar={isReadOnlyInput()}
                                onCancelarVoltar={props.onHide} />
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <ModalWarning
                show={showWarning}
                onHide={onHideWarning}
                message={messageWarning} />
        </>
    );
}

export default ItemLicencaOrganizacaoCadastro;